class p{
  constructor(params_list) {
    this.params_list = params_list;
  }

  get(name){
    return this.params_list[name];
  }
};
const Params_function = () => {
  let aux = window.location.search.replace('?','');
  let params = {};
  aux.split('&').forEach(p=>{
      let a = p.split('=');
      params[a[0]] = a[1]?a[1]:'';
  });
  return new p(params);
};

const Params = Params_function();

export default Params;